import * as React from "react";
import { useFormContext } from "react-hook-form";

import { FormFieldContext } from "./form-field-context";
import { FormItemContext } from "./form-item-context";

/**
 * Field metadata for FormLabel / FormControl / FormMessage (use within FormField + FormItem).
 */
export function useFormField() {
  const fieldContext = React.useContext(FormFieldContext);
  const itemContext = React.useContext(FormItemContext);
  const { getFieldState, formState } = useFormContext();

  const fieldState = getFieldState(fieldContext.name, formState);

  if (!fieldContext) {
    throw new Error("useFormField should be used within <FormField>");
  }

  const { id, controlId } = itemContext;

  return {
    id,
    name: fieldContext.name,
    // A control's own id wins (see FormControl), so the label follows it.
    formItemId: controlId ?? `${id}-form-item`,
    formDescriptionId: `${id}-form-item-description`,
    formMessageId: `${id}-form-item-message`,
    ...fieldState,
  };
}
